export default __webpack_public_path__ + "static/ourservise_mobile-c904c824ac7e7a3ded9aec98c24c3dc8.png";